module.exports = __webpack_public_path__ + "img/L_5S.a0695c01.png";